import React from "react";
import styles from "./TrialNotice.module.css";
import StoreIcon from "../../assets/TrialNotice/wwg-store-icon.svg";

// Figma: Frame 17522 — notice shown to first-year complimentary members on
// the WWG Store, explaining they can browse but not purchase.
export function TrialNotice() {
  return (
    <div className={styles.notice}>
      <div className={styles.iconBadge}>
        <img src={StoreIcon} alt="" className={styles.icon} />
      </div>
      <div className={styles.textBlock}>
        <p className={styles.title}>View Products Now, Buy Later</p>
        <p className={styles.description}>
          First-year complimentary members do not have access to purchase
          items for sale from the WWG Store (online or in person). Full
          access is available with paid Premier Membership.
        </p>
      </div>
    </div>
  );
}

export default TrialNotice;
